var _g, _g2, _g3, _circle, _rect, _path, _rect2, _path2, _rect3, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistenceDeepBreathing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 133,
    viewBox: "0 0 270 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10814_8120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 99C49.6731 99 64 84.6731 64 67C64 49.3269 49.6731 35 32 35C14.3269 35 0 49.3269 0 67C0 84.6731 14.3269 99 32 99Z",
    fill: "#FA4B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8457 55.9231V55.9231C41.8457 58.642 39.6416 60.8462 36.9226 60.8462V60.8462C34.2037 60.8462 31.9995 58.642 31.9995 55.9231V51",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1543 55.9231V55.9231C22.1543 58.642 24.3584 60.8462 27.0774 60.8462V60.8462C29.7963 60.8462 32.0005 58.642 32.0005 55.9231V51",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3086 72.5372C12.3086 69.1526 14.7694 52.2295 24.9203 52.2295C29.2268 52.2295 28.9192 63.4347 28.9192 68.2295C28.9192 76.2295 27.0778 80.5372 16.615 80.5372C12.924 80.5372 12.3086 75.9218 12.3086 72.5372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6914 72.5372C51.6914 69.1526 49.2306 52.2295 39.0797 52.2295C34.7732 52.2295 35.0808 63.4347 35.0808 68.2295C35.0808 76.2295 36.9222 80.5372 47.385 80.5372C51.076 80.5372 51.6914 75.9218 51.6914 72.5372Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10814_8120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 99C145.673 99 160 84.6731 160 67C160 49.3269 145.673 35 128 35C110.327 35 96 49.3269 96 67C96 84.6731 110.327 99 128 99Z",
    fill: "#FA4B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.846 55.9231V55.9231C137.846 58.642 135.642 60.8462 132.923 60.8462V60.8462C130.204 60.8462 128 58.642 128 55.9231V51",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.154 55.9231V55.9231C118.154 58.642 120.358 60.8462 123.077 60.8462V60.8462C125.796 60.8462 128 58.642 128 55.9231V51",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.309 72.5372C108.309 69.1526 110.769 52.2295 120.92 52.2295C125.227 52.2295 124.919 63.4347 124.919 68.2295C124.919 76.2295 123.078 80.5372 112.615 80.5372C108.924 80.5372 108.309 75.9218 108.309 72.5372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.691 72.5372C147.691 69.1526 145.231 52.2295 135.08 52.2295C130.773 52.2295 131.081 63.4347 131.081 68.2295C131.081 76.2295 132.922 80.5372 143.385 80.5372C147.076 80.5372 147.691 75.9218 147.691 72.5372Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10814_8120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224 107C246.091 107 264 89.0914 264 67C264 44.9086 246.091 27 224 27C201.909 27 184 44.9086 184 67C184 89.0914 201.909 107 224 107Z",
    fill: "#FA4B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.307 53.1538V53.1538C236.307 56.5525 233.551 59.3077 230.153 59.3077V59.3077C226.754 59.3077 223.999 56.5525 223.999 53.1538V47",
    stroke: "white",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.693 53.1538V53.1538C211.693 56.5525 214.449 59.3077 217.847 59.3077V59.3077C221.246 59.3077 224.001 56.5525 224.001 53.1538V47",
    stroke: "white",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.386 73.9198C199.386 69.689 202.462 48.5352 215.15 48.5352C220.533 48.5352 220.149 62.5417 220.149 68.5352C220.149 78.5352 217.847 83.9198 204.769 83.9198C200.155 83.9198 199.386 78.1505 199.386 73.9198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.614 73.9198C248.614 69.689 245.538 48.5352 232.85 48.5352C227.467 48.5352 227.851 62.5417 227.851 68.5352C227.851 78.5352 230.153 83.9198 243.231 83.9198C247.845 83.9198 248.614 78.1505 248.614 73.9198Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160.5,
    cy: 21.5,
    r: 1.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 81,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#75BE74"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.5 97L156.5 101L163.5 93",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 81,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#75BE74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 97L60.5 101L67.5 93",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 81,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#75BE74"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 97,
    r: 2,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 97,
    r: 2,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 97,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 18.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 2,
    r: 2,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 126,
    r: 2,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 128.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.5,
    cy: 119.5,
    r: 1.5,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 268.5,
    cy: 131.5,
    r: 1.5,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M258 24L267 15.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190.5 109.5L181.5 118.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.5 9.5L198.5 18.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M233.5 121L238 131",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10814_8120"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 35,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10814_8120"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 35,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10814_8120"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 27,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceDeepBreathing);
export default __webpack_public_path__ + "static/media/persistence-deep-breathing.7379f0b1026b9f52ebc0a02fa63b7aa7.svg";
export { ForwardRef as ReactComponent };